var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { CalenderConfigs } from "@yodlee/common-components/dist/configurations";
import { ResponsiveEnums } from "@yodlee/common-components/dist/types/enumerations";
import { Col, Divider, Form, Icon, Modal, Row, Spin, Typography } from "antd";
import moment from "moment";
import React from "react";
import MediaQuery from "react-responsive";
import { FormFieldConfigs } from "../../configurations";
import { DataUtils } from "../../utilities";
import LeftView from "./left-view";
import RightView from "./right-view";
moment.updateLocale('en', {
    calendar: CalenderConfigs.MOMENT_CALENDER
});
var UpdateSiteAlert = /** @class */ (function (_super) {
    __extends(UpdateSiteAlert, _super);
    function UpdateSiteAlert() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isLoading: false,
            onFormUpdated: false
        };
        _this.componentDidUpdate = function (prevProps, prevState) {
            var onFormUpdate = _this.props.onFormUpdate;
            var isFieldsTouched = _this.props.form.isFieldsTouched;
            var onFormUpdated = _this.state.onFormUpdated;
            var oldOnFormUpdated = prevState.onFormUpdated;
            if (onFormUpdate && isFieldsTouched() && !onFormUpdated && !oldOnFormUpdated) {
                _this.setState({
                    onFormUpdated: true
                }, function () {
                    onFormUpdate();
                });
            }
        };
        _this.componentDidMount = function () {
            var _a = _this.props, authentication = _a.authentication, siteAlert = _a.siteAlert;
            DataUtils.systemConfig(authentication).get().then(function (onload) {
                _this.setState({ onload: onload });
            });
            if (siteAlert.id) {
                DataUtils.siteAlerts(authentication).getOne(siteAlert.id).then(function (siteAlert) {
                    _this.setState({ siteAlert: siteAlert });
                });
            }
        };
        _this.onSubmit = function (e) {
            var _a = _this.props.form, validateFieldsAndScroll = _a.validateFieldsAndScroll, resetFields = _a.resetFields;
            var siteAlert = _this.state.siteAlert;
            var _b = _this.props, authentication = _b.authentication, onUpdate = _b.onUpdate;
            e.preventDefault();
            e.stopPropagation();
            var updateSiteAlert = function (values) {
                _this.setState({
                    isLoading: true
                });
                var newSiteAlert = __assign({}, values);
                var parsedStartTime = newSiteAlert.startTime ? moment(newSiteAlert.startTime).valueOf() : undefined;
                if (parsedStartTime !== (siteAlert === null || siteAlert === void 0 ? void 0 : siteAlert.startTime)) {
                    newSiteAlert.startTime = parsedStartTime;
                }
                else {
                    delete newSiteAlert.startTime;
                }
                var parsedTentativeETA = newSiteAlert.tentativeETA ? moment(newSiteAlert.tentativeETA).valueOf() : 0;
                if (parsedTentativeETA !== (siteAlert === null || siteAlert === void 0 ? void 0 : siteAlert.tentativeETA)) {
                    newSiteAlert.tentativeETA = parsedTentativeETA;
                }
                else {
                    delete newSiteAlert.tentativeETA;
                }
                newSiteAlert.issues = newSiteAlert.issues.map(function (issueId) { return ({ id: issueId }); });
                DataUtils.siteAlerts(authentication).updateOne(siteAlert === null || siteAlert === void 0 ? void 0 : siteAlert.id, newSiteAlert).then(function (siteAlert) {
                    _this.setState({ siteAlert: siteAlert });
                    onUpdate && onUpdate(siteAlert);
                    resetFields([
                        "updates.".concat(FormFieldConfigs.COMMENT.key),
                        FormFieldConfigs.RCA.key
                    ]);
                }).finally(function () {
                    _this.setState({
                        isLoading: false,
                        onFormUpdated: false
                    });
                });
            };
            validateFieldsAndScroll(function (err, values) {
                console.debug('Received values of serviceRequestForm: ', values, err);
                if (!err && (siteAlert === null || siteAlert === void 0 ? void 0 : siteAlert.id)) {
                    Modal.confirm({
                        keyboard: false,
                        title: React.createElement(Typography.Title, { className: "color-blue-5", level: 2 },
                            "A notification will be sent out to customers. Are you sure?",
                            React.createElement("br", null)),
                        icon: null,
                        width: "450px",
                        okText: "Send Update",
                        cancelButtonProps: { type: "danger" },
                        onOk: function () { return updateSiteAlert(values); }
                    });
                }
            });
        };
        _this.render = function () {
            var _a = _this.state, onload = _a.onload, siteAlert = _a.siteAlert, isLoading = _a.isLoading;
            return (onload && siteAlert ?
                React.createElement(MediaQuery, { minWidth: ResponsiveEnums.SCREEN_SIZE.MD, minDeviceWidth: ResponsiveEnums.SCREEN_SIZE.MD }, function (matches) {
                    return React.createElement(Form, { onSubmit: _this.onSubmit, colon: false, layout: "horizontal" },
                        React.createElement(Row, { type: "flex", style: { width: '100%' } },
                            React.createElement(Col, { xxl: 7, xl: 7, lg: 7, md: 24, sm: 24, xs: 24, order: matches ? 1 : 3, className: matches ? "padding-right-lg" : "" },
                                React.createElement(LeftView, { form: _this.props.form, siteAlert: siteAlert, onload: onload, isLoading: isLoading })),
                            React.createElement(Col, { xs: 24, sm: 24, md: 24, lg: 0, xl: 0, xxl: 0, order: 2 },
                                React.createElement(Divider, null)),
                            React.createElement(Col, { xxl: 17, xl: 17, lg: 17, md: 24, sm: 24, xs: 24, order: matches ? 3 : 1, className: matches ? "padding-left-lg border-left" : "" },
                                React.createElement(RightView, { form: _this.props.form, onload: onload, siteAlert: siteAlert, isLoading: isLoading }))));
                }) :
                React.createElement(Row, { type: "flex", style: { height: "80vh" }, justify: "center", align: "middle" },
                    React.createElement(Col, null,
                        React.createElement(Spin, { size: "large", indicator: React.createElement(Icon, { type: "loading" }) }))));
        };
        return _this;
    }
    return UpdateSiteAlert;
}(React.Component));
export default Form.create({ name: 'update-site-alert' })(UpdateSiteAlert);
//# sourceMappingURL=index.js.map